import { ArrowRight, ShieldCheck, Server } from "lucide-react";
import { Calculator } from "@/components/Calculator";

const TRUST = [
    { icon: ShieldCheck, label: "DSGVO-konform" },
    { icon: Server, label: "Server in Deutschland" },
];

export const Hero = () => (
    <section id="top" className="relative overflow-hidden pt-32 pb-20 lg:pt-40 lg:pb-28" aria-labelledby="hero-heading">
        <div
            className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 h-[480px] w-[720px] rounded-full opacity-30"
            style={{ background: "radial-gradient(closest-side, rgba(16,185,129,0.22), transparent)" }}
            aria-hidden="true"
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
            <div>
                <p className="fade-up font-mono-label text-xs uppercase tracking-[0.2em] text-emerald-400">
                    KI-Automatisierung für KMU
                </p>
                <h1
                    id="hero-heading"
                    className="fade-up fade-up-delay-1 mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.15]"
                >
                    Wie viel Zeit kostet Sie{" "}
                    <span className="text-emerald-400">dieselbe Aufgabe</span> – zum hundertsten Mal?
                </h1>
                <p className="fade-up fade-up-delay-2 mt-6 text-base sm:text-lg text-[#9CA3AF] leading-relaxed max-w-xl">
                    Wiederkehrende Kundenanfragen, manuelle Dateneingabe, Termin-Pingpong: Solche Routineaufgaben
                    kosten kleine und mittlere Unternehmen täglich Stunden, die fürs Kerngeschäft fehlen. Kirenzo
                    automatisiert genau diese Prozesse mit KI – individuell auf Ihr Unternehmen zugeschnitten, egal
                    ob Kanzlei, Hausverwaltung, Handwerk oder Dienstleistung.
                </p>
                <div className="fade-up fade-up-delay-3 mt-8 flex flex-col sm:flex-row gap-4 sm:items-center">
                    <a
                        href="#demo"
                        data-testid="hero-cta-button"
                        className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-7 py-3.5 text-base font-semibold text-[#0B0F17] transition-all duration-200 hover:bg-emerald-600 hover:shadow-[0_0_32px_rgba(16,185,129,0.35)]"
                    >
                        Kostenlose Demo anfragen
                        <ArrowRight className="h-4 w-4" aria-hidden="true" />
                    </a>
                    <span className="text-sm text-[#6B7280]">Unverbindlich. Antwort innerhalb von 24 Stunden.</span>
                </div>
                <ul className="fade-up fade-up-delay-3 mt-10 flex flex-wrap gap-x-6 gap-y-3">
                    {TRUST.map(({ icon: Icon, label }) => (
                        <li key={label} className="flex items-center gap-2 text-sm text-[#9CA3AF]">
                            <Icon className="h-4 w-4 text-emerald-500" aria-hidden="true" />
                            {label}
                        </li>
                    ))}
                </ul>
            </div>
            <Calculator />
        </div>
    </section>
);
